import { useEffect } from "react";
import { useLocation } from "react-router-dom";

const SITE = "Trout Start";
const BASE = "https://troutstart.com";

function setMeta(selector, attr, value) {
    let el = document.head.querySelector(selector);
    if (!el) {
        el = document.createElement("meta");
        const [kind, name] = selector.match(/\[(.+?)="(.+?)"\]/).slice(1);
        el.setAttribute(kind, name);
        document.head.appendChild(el);
    }
    el.setAttribute(attr, value);
}

export default function SEO({ title, description, path = "" }) {
    const { pathname } = useLocation();
    const url = `${BASE}${path || pathname}`;
    const fullTitle = title ? `${title} | ${SITE}` : `${SITE} — Fly Fishing Guides, Checklists & Gear`;

    useEffect(() => {
        document.title = fullTitle;
        setMeta('meta[name="description"]', "content", description);
        setMeta('meta[property="og:title"]', "content", fullTitle);
        setMeta('meta[property="og:description"]', "content", description);
        setMeta('meta[property="og:url"]', "content", url);
        setMeta('meta[name="twitter:title"]', "content", fullTitle);
        setMeta('meta[name="twitter:description"]', "content", description);
        let link = document.head.querySelector('link[rel="canonical"]');
        if (!link) {
            link = document.createElement("link");
            link.rel = "canonical";
            document.head.appendChild(link);
        }
        link.href = url;
    }, [fullTitle, description, url]);

    return null;
}
